import dateTimeFormat from "../utility/dateTimeFormat";
import React, {Component} from "react";
import utility from "../utility/utility";
import Linkify from 'react-linkify';

const EXTENSIONS = {
    IMAGES: ["jpg", "png", "jpeg", "ico", "bmp", "gif", "icns", "svg"],
    AUDIO: ["mp3", "wav", "ogg"],
    VIDEO: ["mp4", "3gp", "mkv", "mov", "flv", "avi", "wmv", "webm", "3gpp", "mpeg14"],
    DOCUMENT: ["doc", "docx", "xls", "xlsx", "pdf", "txt", "csv", "eps", "odf", "ppt", "pptx14"]

};

function getAttachmentType(url) {
    let parseUrl = removeURLParameter(url);
    var ext = parseUrl.split(".");
    return ext[ext.length - 1].toLowerCase();

}

function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {


        return urlparts[0];
    }
    return url;
}



let userAvatar;
let oldDate;
class LounageChatMessages extends Component {

    constructor() {
        super();
        this.state={'openAttachmentModal':false,attachmentUrl:'',attachmentType:''}
    }
    openAttachment=(url,type)=>{
        console.log(url,type);
        this.setState({'openAttachmentModal':!this.state.openAttachmentModal,attachmentUrl:url,attachmentType:type});
    }
    showHideAttachmentModal=()=>{
        this.setState({'openAttachmentModal':false});
    }
    componentDecorator = (href, text, key) => (
        <a href={href} key={key} target="_blank" className='text-primary'>
            {text}
        </a>
    );
    render() {
        return (
            <React.Fragment>
                { this.props.chatConversations && this.props.chatConversations.length?
                    this.props.chatConversations.map((conversion, index) => {
                        let currentDate = dateTimeFormat.getDateSeprator(conversion.created_at);
                        let messageTime = this.props.troopConnection.getMessageTime(conversion.created_at);
                        let user = conversion.sender_id + '' + conversion.receiver_id + '' + currentDate + '' + messageTime;
                        let chatHtml = '';
                        if (index === 0) {
                            userAvatar = '';
                            oldDate = '';
                        }
                        if (currentDate !== oldDate) {
                            oldDate = currentDate;
                            chatHtml = <div className="devider px-4 position-relative my-4" key={index + 1}>
                                <hr/>
                                <span>{oldDate}</span></div>;
                            index = index + 1;
                        }

                        if (conversion.message_type === this.props.troopConnection.messageType().TEXT || conversion.message_type === this.props.troopConnection.messageType().ATTACHMENT){

                            conversion.sender_id = parseInt(conversion.sender_id);
                            index = index + 1;
                            let message;
                            //console.log(String.fromCharCode(),"parseSite");
                            if (parseInt(conversion.message_type) === 0) {
                                // console.log(parser.parseFromString(this.props.troopConnection.parseMessage(conversion.message), 'text/html'),"console");
                                message = <div ><Linkify componentDecorator={this.componentDecorator} properties={{target: '_blank', style: {color: 'blue !important', fontWeight: 'bold'}}}> {conversion.message}</Linkify></div>
                            } else {
                                let attachmentType = getAttachmentType(conversion.attachment);
                                if (EXTENSIONS.IMAGES.indexOf(attachmentType) !== -1) {
                                    message =


                                        <img  src={conversion.attachment} className="rounded overflow-hidden  img-fluid message-attachments" onClick={e=>this.openAttachment(conversion.attachment,1)} alt='attachemnt'/>


                                } else if (EXTENSIONS.VIDEO.indexOf(attachmentType) !== -1) {
                                    message =
                                        <video width="320" height="240" className='rounded overflow-hidden message-attachments'
                                               controlsList="nodownload"  onClick={e=>this.openAttachment(conversion.attachment,2)}>
                                            <source src={conversion.attachment} type="video/mp4"/>
                                        </video>


                                } else if (EXTENSIONS.AUDIO.indexOf(attachmentType) !== -1) {
                                    message =

                                        <audio width="320" height="240" controls className='message-attachments'
                                               controlsList="nodownload">
                                            <source src={conversion.attachment} type="video/mp4"/>
                                        </audio>


                                } else {
                                    message = <a className="chat-attachment-type" href={conversion.attachment} target='_blank' rel="noopener">
                                        <img  alt='' src={process.env.PUBLIC_URL + utility.getFileAttachmentIcon(attachmentType)} className="img-fluid"/>
                                        <span className="chat-attachment-name text-truncate">
                                    {utility.getTrimmedAttachmentNameString(utility.getFileName(removeURLParameter(conversion.attachment)))}
                                </span>
                                    </a>

                                }
                            }


                            chatHtml=[chatHtml, <div className="p-3 peer-box" key={index+1}>
                                <div className="d-flex justify-content-between">
                                    <div className="peer-img"  style={{background: 'url(' + conversion.profilePic + ') no-repeat center / cover'}}>
                                        {conversion.profilePic===''?utility.acronym(conversion.name):''}
                                    </div>
                                    <div className="peer-details">
                                        <div className="peer-name">
                                            {conversion.name}
                                        </div>
                                        <div className="peer-message d-flex">
                                            {message}
                                            {(parseInt(conversion.message_type) === 0)?'':<a href={conversion.attachment} className="download-file" download target='_blank' rel="noopener"><img  alt='' src={process.env.PUBLIC_URL +'/images/tmChat/attachment_download_icon.svg'}/></a>}

                                        </div>
                                    </div>
                                    <div className="message-time">
                                        {messageTime}
                                    </div>
                                </div>
                            </div>];
                            if (userAvatar !== user) {
                                userAvatar = user;
                            }
                            chatHtml = chatHtml.filter(item => item !== undefined && item !== null && item !== "");
                            return (
                                chatHtml
                            );
                        }else{
                            /*let messageDisplay='';
                                 if(conversion.message_type===this.props.troopConnection.messageType().MESSAGE_TYPE_ROOM_MEMBER_JOINED ) {
                                     messageDisplay = conversion.name + " Joined";
                                 }else if(parseInt(conversion.message_type)===29){
                                     messageDisplay = conversion.name + " Left";

                                 }
                              if(messageDisplay!=='') {
                                  chatHtml = [chatHtml, <div key={index + 1}>
                                      <div className="group-notification-wrapper px-4 position-relative"
                                           key={index + 1}>
                                          <span className='group-notification-wrapper-span'>{messageDisplay}</span>
                                      </div>
                                  </div>]
                              }else{
                                  chatHtml = [chatHtml, ''];
                              }*/
                            chatHtml = [chatHtml, ''];
                            chatHtml = chatHtml.filter(item => item !== undefined && item !== null && item !== "");

                            return  (chatHtml);
                        }
                    })
                    :''}
                {this.state.openAttachmentModal?
                    <React.Fragment>
                        <div className="modal-backdrop show"/>
                        <div className="modal chat-open-attachment-modal d-block" >
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content rounded-0">
                                    <div className="modal-header p-0">
                                        <button type="button" className="close close-attachments-modal"  data-dismiss="modal" aria-label="Close" onClick={this.showHideAttachmentModal}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body p-0 text-center">
                                        {this.state.attachmentType===1?<img  alt='' src={this.state.attachmentUrl} className='img-fluid'/>:<video className="" controls ><source src={this.state.attachmentUrl}/></video>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                    :''}
            </React.Fragment>
        );
    };
}

export default LounageChatMessages;
